import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

let sceneTextEnterI: any = null,
    sceneTextLeaveI: any = null;
export default function I() {
    const { useLang, useRouter, useEffect, useState, useRef, gtm, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [textEnter, setTextEnter] = useState(false);
    const [active, setActive] = useState(0);
    const SITE_JP = 'jp';

    const handleChangTab = (n: number) => {
        if (active === n) return;
        setActive(n);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: 'none',
            button_name: t(`secI_list${n + 1}_title`),
        });
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (sceneTextEnterI) {
                    AniContainer.removeScene(sceneTextEnterI);
                    sceneTextEnterI = null;
                }
                if (sceneTextLeaveI) {
                    AniContainer.removeScene(sceneTextLeaveI);
                    sceneTextLeaveI = null;
                }

                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                sceneTextEnterI = AniContainer.create({
                    triggerElement: '.dpu-detail-I',
                    triggerHook: 1,
                    offset: startH, //textTarget?.offsetHeight,
                    duration: 200, //textTarget?.offsetHeight / 2,
                    onEnter: () => setTextEnter(true),
                    //onLeave: () => setTextEnter(false),
                });
                // sceneTextEnterI = AniContainer.create({
                //     triggerElement: '.dpu-detail-I .text-info',
                //     triggerHook: 1,
                //     offset:  textTarget?.offsetHeight,
                //     duration: textTarget?.offsetHeight / 2,
                //     onEnter: () => setTextEnter(true),
                // });
                // sceneTextLeaveI = AniContainer.create({
                //     triggerElement: '.dpu-detail-I .text-info',
                //     triggerHook: 1,
                //     offset: 0,
                //     duration: window.innerHeight * 2,
                //     onLeave: () => setTextEnter(false),
                // });
            };
            resizeAni();
            //window.addEventListener('resize', resizeAni);
            return () => {
                if (sceneTextEnterI) {
                    AniContainer.removeScene(sceneTextEnterI);
                    sceneTextEnterI = null;
                }
                if (sceneTextLeaveI) {
                    AniContainer.removeScene(sceneTextLeaveI);
                    sceneTextLeaveI = null;
                }

                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    return (
        <section className={`dpu-detail-I dpu-detail-section ${css['dpu-detail-I']}`}>
            <div className={`text-info ${textEnter ? 'enter' : ''}`}>
                <p className="subtitle">{t('secI_subtitle')}</p>
                <h2 className="title">{t('secI_title')}</h2>
                <p className="desc">
                    {t.rich('secI_desc', {
                        w: (text: string) => <span className="white-text">{text}</span>,
                        sup: (text: string) => <sup className="sup">{text}</sup>,
                    })}
                </p>
            </div>
            <ul className="videos">
                <li className={`video ${active === 0 ? 'active' : ''}`}>
                    <video
                        className="fullImgs"
                        src={'/responsive/video/delta-pro-ultra/launch/9_1.mp4'}
                        muted
                        autoPlay
                        playsInline
                        loop
                        preload="auto"
                        width="100%"
                        height="100%"
                        poster="/responsive/picture/delta-pro-ultra/launch/9_1.jpg"
                        aria-label={t('secI_list1_title')}
                        // onEnded={handlePlayEnd}
                    />
                    <div className="info-box">
                        <svg className="video-icon" xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70" fill="none">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M23.3335 8.75012H20.4169V14.5835H23.3335V8.75012ZM35.0003 29.1668H23.3336V37.9168H35.0003V29.1668ZM35.0003 40.8334H23.3336V49.5834H35.0003V40.8334ZM23.3336 52.5003H35.0003V61.2503H23.3336V52.5003ZM49.5835 29.1668H37.9168V37.9168H49.5835V29.1668ZM37.9168 40.8334H49.5835V49.5834H37.9168V40.8334ZM49.5835 52.5003H37.9168V61.2503H49.5835V52.5003ZM52.5001 29.1668H64.1668V37.9168H52.5001V29.1668ZM8.75033 26.2501V29.1668H2.91699L2.91699 26.2501H8.75033ZM36.3121 15.3343L34.2497 13.272L30.1249 17.3967L32.1873 19.4591L36.3121 15.3343ZM11.5632 35.9577L13.6256 38.0201L9.50077 42.1449L7.43838 40.0825L11.5632 35.9577ZM11.5632 19.4588L13.6256 17.3964L9.50079 13.2716L7.43839 15.334L11.5632 19.4588ZM31.9804 26.2504H20.4173V37.8136C15.4701 37.1061 11.6671 32.8515 11.6671 27.7086C11.6671 22.0707 16.2375 17.5003 21.8754 17.5003C27.0182 17.5003 31.2728 21.3033 31.9804 26.2504ZM51.3296 50.744L58.3336 61.2501L65.3377 50.744H60.5211V41.2648H56.1461V50.744L51.3296 50.744Z"
                                fill="#49F4FF"
                            />
                        </svg>
                        <div className="video-info">
                            <h2 className="video-title">{t('secI_list1_title')}</h2>
                            <p className="video-desc">{t('secI_list1_desc')}</p>
                        </div>
                    </div>
                </li>
                <li className={`video ${active === 1 ? 'active' : ''}`}>
                    <video
                        className="fullImgs"
                        src={'/responsive/video/delta-pro-ultra/launch/9_2.mp4'}
                        muted
                        autoPlay
                        loop
                        playsInline
                        preload="auto"
                        width="100%"
                        height="100%"
                        poster="/responsive/picture/delta-pro-ultra/launch/9_2.jpg"
                        aria-label={t('secI_list2_title')}
                        // onEnded={handlePlayEnd}
                    />
                    <div className="info-box">
                        <svg className="video-icon" xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70" fill="none">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M23.332 8.75012H20.4154V14.5835H23.332V8.75012ZM34.9985 29.167H23.3319V37.917H34.9985V29.167ZM34.9985 40.8336H23.3319V49.5836H34.9985V40.8336ZM23.3319 52.5003H34.9985V61.2503H23.3319V52.5003ZM49.581 29.167H37.9144V37.917H49.581V29.167ZM37.9144 40.8336H49.581V49.5836H37.9144V40.8336ZM49.581 52.5003H37.9144V61.2503H49.581V52.5003ZM52.5021 29.167H64.1688V37.917H52.5021V29.167ZM8.74935 26.2501V29.1668H2.91602L2.91602 26.2501H8.74935ZM36.3114 15.3343L34.249 13.2719L30.1242 17.3967L32.1866 19.4591L36.3114 15.3343ZM11.5604 35.9578L13.6228 38.0202L9.49798 42.145L7.43558 40.0826L11.5604 35.9578ZM11.5601 19.4588L13.6225 17.3965L9.4977 13.2717L7.43531 15.3341L11.5601 19.4588ZM31.9792 26.2504H20.4153V37.8135C15.4685 37.1057 11.6659 32.8512 11.6659 27.7086C11.6659 22.0707 16.2363 17.5003 21.8742 17.5003C27.017 17.5003 31.2716 21.3033 31.9792 26.2504ZM65.3394 51.7712L58.3354 41.2651L51.3313 51.7712H56.1479V61.2503H60.5229V51.7712H65.3394Z"
                                fill="#F7A40A"
                            />
                        </svg>
                        <div className="video-info">
                            <h2 className="video-title">{t('secI_list2_title')}</h2>
                            <p className="video-desc">{t('secI_list2_desc')}</p>
                            {['us', 'ca'].includes(locale) && <p className="video-tips">{t('secI_list2_tips')}</p>}
                            {locale === 'us' && (
                                <Link className="video-link" href={'https://blog.ecoflow.com/us/saving-money-with-shp2'} target="_blank">
                                    {t('secI_list1_link')}
                                </Link>
                            )}
                        </div>
                    </div>
                </li>
            </ul>
            <ul className="tabs">
                <li className={`tab ${active === 0 ? 'active' : ''}`} onClick={() => handleChangTab(0)}>
                    {t('secI_list1_title')}
                </li>
                <li className={`tab ${active === 1 ? 'active' : ''}`} onClick={() => handleChangTab(1)}>
                    {t('secI_list2_title')}
                </li>
            </ul>
            {/* {SITE_JP === locale && <p className="tip">{t('secI_tip')}</p>} */}
        </section>
    );
}
